import MuiButton from "@material-ui/core/Button";
import { useTranslate } from 'react-admin';
import { Link } from "react-router-dom";


export const LinkButton = ({ linkPath, text }) => {
  const translate = useTranslate();
	return (
      <MuiButton
          component={Link}
          to={linkPath}
          size="small"
          color="primary"
          variant="outlined"
      >
          {translate(text)}
      </MuiButton>
    );
  };
  